import { createContext, useEffect, useState } from 'react';
import NotificationService from 'services/NotificationService';
import { createNotification } from 'utils/noti';

const NotificationContext = createContext();

const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState([]);
    const [consumerNotification, setConsumerNotification] = useState([]);
    const [location, setLocation] = useState('VN');
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);

    const [countNotification, setCountNotification] = useState(0);
    const [unreadConsumerNotification, setUnreadConsumerNotification] = useState(0);
    const [isChangeNotification, setIsChangeNotification] = useState(false);

    const getNoti = async () => {
        setLoading(true);
        const res = await NotificationService.getNoti(page);
        if(res.code === 200) {
            const data = res.data.records.map(e => ({
                ...e.message,
                id: e.id,
                read: e.status === 'read' ? true : false
            }))
            setConsumerNotification([...consumerNotification, ...data]);
            setUnreadConsumerNotification(res.data.pageinfo.unread);
            setLoading(false)
        }
    }

    useEffect(() => {
        getNoti();
    }, [page])

    return (
        <NotificationContext.Provider
            value={{
                notification,
                location,
                setNotification,
                setLocation,
                countNotification,
                isChangeNotification,
                setIsChangeNotification,
                setCountNotification,
                consumerNotification,
                setConsumerNotification,
                unreadConsumerNotification, 
                setUnreadConsumerNotification,
                loading,
                setLoading,
                page,
                setPage
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
};

export { NotificationContext, NotificationProvider };
